import { useEffect, useState } from 'react';
import { AppDialog } from '../../../../components/common/CustomMdal';
import FormDropdown from '../../../../components/common/FormDropdown';
import type { LeaguePermissionRole } from '../api/requestApi';

interface AddRoleModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  playerName: string;
  submitting: boolean;
  onAssign: (roleName: LeaguePermissionRole) => void;
}

const ROLE_OPTIONS: { value: LeaguePermissionRole; label: string }[] = [
  { value: 'LEAGUE_ADMIN', label: 'League Admin' },
  { value: 'LEAGUE_SCORER', label: 'League Scorer' },
  { value: 'LEAGUE_STREAMER', label: 'League Streamer' },
];

export const AddRoleModal: React.FC<AddRoleModalProps> = ({
  open,
  onOpenChange,
  playerName,
  submitting,
  onAssign,
}) => {
  const [roleName, setRoleName] = useState<string>('');

  useEffect(() => {
    if (!open) setRoleName('');
  }, [open]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!roleName) return;
    onAssign(roleName as LeaguePermissionRole);
  };

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Add Role"
      size="sm"
      className="add-role-dialog"
    >
      <form onSubmit={handleSubmit} className="add-role-form">
        <p className="add-role-player-name">{playerName}</p>
        <div className="add-role-field">
          <label className="add-role-label" htmlFor="add-role-select">
            Select Role*
          </label>
          <FormDropdown
            id="add-role-select"
            value={roleName}
            onChange={setRoleName}
            options={ROLE_OPTIONS}
            placeholder="Select a role"
          />
        </div>

        <div className="add-role-footer">
          <button
            type="button"
            className="add-role-cancel"
            onClick={() => onOpenChange(false)}
            disabled={submitting}
          >
            Cancel
          </button>
          <button type="submit" className="add-role-submit" disabled={!roleName || submitting}>
            {submitting ? 'Assigning...' : 'Assign Role'}
          </button>
        </div>
      </form>
    </AppDialog>
  );
};
